const genderOptions=[
    {
        id: 1,
        name: 'Male',
        value: 'male'
    },
    {
        id: 2,
        name: 'Female',
        value: 'female'
    },
    {
        id: 3,
        name: 'Other',
        value: 'other'
    }

]

export default genderOptions